import React, { Component } from 'react';

import SidebarComponent from '../components/SidebarComponent';
import NavbarComponent from '../components/NavbarComponent';
import FormAccessoryComponent from '../components/FormAccessoryComponent';
import FormBoxGameComponent from '../components/FormBoxGameComponent';
import HeaderComponent from '../components/HeaderComponent';
import { validateSession } from '../utils/functions';
import {
    buildProductPayload,
    getProductImageFolder,
    getProductsListPath,
} from '../utils/productForm';
import { navigateTo } from '../utils/navigation';
import { uploadProductImages } from '../utils/productImages';

var config = process.env;

class AddProductPage extends Component {

    constructor() {
        super();
        this.state = {
            uploadValue: 0,
            checked: false,
            disabled: false,
            role: 0,
            productType: null,
        };
    }

    async componentDidMount() {
        const role = await validateSession();
        this.setState({
            checked: true,
            role,
            productType: this.resolveProductType(),
        });
    }

    componentDidUpdate(prevProps) {
        if (prevProps.location.search !== this.props.location.search || prevProps.forcedProductType !== this.props.forcedProductType) {
            const productType = this.resolveProductType();
            if (productType !== this.state.productType) {
                this.setState({ productType });
            }
        }
    }

    resolveProductType = () => {
        if (this.props.forcedProductType != null) {
            return Number(this.props.forcedProductType);
        }

        const params = new URLSearchParams(this.props.location.search);
        const productType = Number(params.get('productType'));
        return productType === 1 || productType === 2 ? productType : null;
    }

    selectProductType = (productType) => {
        navigateTo(`/addProduct?productType=${productType}`);
    }

    handleChangeData = (value) => {
        this.setState({ disabled: true });
        const request = {
            method: 'POST',
            headers: {
                'Content-Type': 'application/json',
                'access-token': localStorage.getItem('token')
            },
            body: JSON.stringify(buildProductPayload(value, this.state.productType))
        };

        fetch(config.REACT_APP_BASE_URL + config.REACT_APP_VERSION + 'product', request)
        .then(results => results.json())
        .then(data => {
            if (data.error > 0) {
                alert(data.message);
                this.setState({ disabled: false });
                if (data.error === 1002) {
                    window.location.href = localStorage.getItem('homePageURL');
                }
            } else {
                this.setState({ uploadValue: 5 });
                this.uploadImages(value.images, data.data.code);
            }
        });
    }

    uploadImages = (images, code) => {
        const basePath = getProductImageFolder(this.state.productType, code);

        uploadProductImages(basePath, images, (percent) => this.setState({ uploadValue: percent }))
            .then(() => this.redirect())
            .catch((error) => {
                // El producto YA se creó: lo que falló son las imágenes. Antes esto se tragaba con
                // un console.log y se redirigía igual, así que el producto quedaba sin foto y
                // nadie se enteraba hasta verlo en la tienda. Ahora se avisa — pero se redirige
                // igual y NO se re-habilita el form: dejarlo habilitado invita a tocar Guardar de
                // nuevo, y ese botón hace otro POST /product, o sea un producto duplicado. Las
                // imágenes se cargan desde Editar, que es idempotente.
                alert(`${error.message || 'No se pudieron subir las imágenes'}\n\nEl producto se creó igual: cargá las imágenes desde Editar.`);
                this.redirect();
            });
    }

    redirect = () => {
        navigateTo(getProductsListPath(this.state.productType));
    }

    renderSelector = () => {
        return (
            <>
                <HeaderComponent title="Productos" subtitle="Nuevo producto" />
                <p style={{ marginTop: '-8px', marginBottom: '24px', color: '#6c757d' }}>
                    Elegí qué querés cargar para continuar.
                </p>
                <div className="card card-small mb-4">
                    <div className="card-body p-4">
                        <div className="row">
                            <div className="col-md-6 mb-3">
                                <button
                                    type="button"
                                    className="btn btn-outline-primary"
                                    style={{ width: '100%', minHeight: '120px' }}
                                    onClick={() => this.selectProductType(1)}>
                                    <div style={{ fontSize: '18px', fontWeight: '600' }}>Juego</div>
                                    <div style={{ marginTop: '8px', whiteSpace: 'normal' }}>Carga juegos de caja o de cartas con sus atributos específicos.</div>
                                </button>
                            </div>
                            <div className="col-md-6 mb-3">
                                <button
                                    type="button"
                                    className="btn btn-outline-dark"
                                    style={{ width: '100%', minHeight: '120px' }}
                                    onClick={() => this.selectProductType(2)}>
                                    <div style={{ fontSize: '18px', fontWeight: '600' }}>Accesorio</div>
                                    <div style={{ marginTop: '8px', whiteSpace: 'normal' }}>Carga fundas, bolsos, dados, cajas y otros accesorios.</div>
                                </button>
                            </div>
                        </div>
                    </div>
                </div>
            </>
        );
    }

    renderForm = () => {
        if (this.state.productType === 2) {
            return (
                <FormAccessoryComponent
                    onChangeData={this.handleChangeData}
                    uploadValue={this.state.uploadValue}
                    disabled={this.state.disabled}
                    role={this.state.role}
                />
            );
        }

        return (
            <FormBoxGameComponent
                onChangeData={this.handleChangeData}
                uploadValue={this.state.uploadValue}
                disabled={this.state.disabled}
                role={this.state.role}
            />
        );
    }

    render() {
        if (!this.state.checked) {
            return (<div></div>);
        }

        return (
            <div className="container-fluid">
                <div className="row">
                    <SidebarComponent itemSelected={4} role={this.state.role} />
                    <main className="main-content col-lg-10 col-md-9 col-sm-12 p-0 offset-lg-2 offset-md-3">
                        <NavbarComponent role={this.state.role} />
                        <div className="main-content-container container-fluid px-4 mb-4">
                            {this.state.productType == null ? this.renderSelector() : this.renderForm()}
                        </div>
                    </main>
                </div>
            </div>
        );
    }
}

export default AddProductPage;
